import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchConversionCampaignLinksThunk } from '../../redux-stores/slices/conversionCampaignSlice';
import { AppDispatch, RootState } from '../../redux-stores/store';
import InfiniteScroll from 'react-infinite-scroll-component';
import Masonry from 'react-masonry-css';
import imagePlaceholder from '../../assets/images/image-placeholder.png';
import { copyToClipboard, extractOrigin } from '../../utils/helpers';
const breakpointColumnsObj = {
    default: 2,
    600: 1,
};
const ConversionCampaignLinks = () => {

    const { campaignId } = useParams();
    const dispatch: AppDispatch = useDispatch();

    const data = useSelector((state: RootState) => state.conversionCampaigns.links[campaignId!]);

    const links = data?.list ?? [];
    const has_more = data?.has_more ?? true;
    const page = data?.page ?? 1;

    const linksLoading = useSelector((state: RootState) => state.conversionCampaigns.linksLoading);
    const nextPage = () => {
        if (has_more && !linksLoading) {
            const nextPageNumber = page + 1;
            fetchCampaignLinks(nextPageNumber)
        }

    }

    const fetchCampaignLinks = useCallback(async (pageNumber: number, force: boolean = false) => {
        if (campaignId)
            await dispatch(fetchConversionCampaignLinksThunk({ campaignId, page: pageNumber, force }));
    }, [dispatch, campaignId]);

    useEffect(() => {
        if (campaignId) {
            fetchCampaignLinks(1);
        }
    }, [campaignId])

    return (
        <div>
            <InfiniteScroll
                dataLength={links.length} // Number of currently loaded campaigns
                next={nextPage}
                hasMore={has_more} // True if there are more campaigns to load
                loader={<></>}
            >
                {
                    links.map((link, i) => {
                        const url = link.title ?? link.url;
                        return (
                            <div className="app-card m-3" key={i}>
                                <a href={link.url} target='_blank' className="link-metadata">
                                    <div className="link-thumbnail bg-image bgc-white" style={{ backgroundImage: `url(${link.thumbnail_url ?? imagePlaceholder})` }}></div>
                                    <div className="d-flex flex-column justify-content-center">
                                        <div className="link-title">{url.length > 50 ? url.substring(0, 50) + '...' : url}</div>
                                        <div className="link-url">{extractOrigin(link.url)}</div>
                                    </div>
                                </a>
                                <button className='btn btn-outline-primary w-100' onClick={() => copyToClipboard(link.short_url, "Short URL copied to your clipboard!")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M5 9.1665C5 6.80948 5 5.63097 5.73223 4.89874C6.46447 4.1665 7.64298 4.1665 10 4.1665H12.5C14.857 4.1665 16.0355 4.1665 16.7678 4.89874C17.5 5.63097 17.5 6.80948 17.5 9.1665V13.3332C17.5 15.6902 17.5 16.8687 16.7678 17.6009C16.0355 18.3332 14.857 18.3332 12.5 18.3332H10C7.64298 18.3332 6.46447 18.3332 5.73223 17.6009C5 16.8687 5 15.6902 5 13.3332V9.1665Z" stroke="var(--primary)" strokeWidth="1.25" />
                                        <path d="M5 15.8332C3.61929 15.8332 2.5 14.7139 2.5 13.3332V8.33317C2.5 5.19047 2.5 3.61913 3.47631 2.64281C4.45262 1.6665 6.02397 1.6665 9.16667 1.6665H12.5C13.8807 1.6665 15 2.78579 15 4.1665" stroke="var(--primary)" strokeWidth="1.25" />
                                    </svg>
                                    <span>Copy Link</span>
                                </button>
                            </div>
                        )
                    })
                }
                {
                    !links.length && !linksLoading && <div className="conversion-campaign-link-card align-items-center mt-3">No links found</div>
                }
            </InfiniteScroll>
        </div>
    )
}

export default ConversionCampaignLinks